"use strict";

exports.__esModule = true;
exports["default"] = void 0;

/**
 * Chains function calls together, iterating through each function
 * with the result of the previous.
 * @param {...any} fns An array of functions to be chained
 * @param x A value to be passed into the first function call.
 * @returns {*} The result of all of the chained function calls.
 */
var pipe = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (x) {
    return fns.reduce(function (v, f) {
      return f(v);
    }, x);
  };
};

var _default = pipe;
exports["default"] = _default;